import { c as _c } from "react/compiler-runtime";
import type { INotificationGeneric } from "@/types/feed.types";
import NotificationHeader from "../subcomponents/NotificationHeader";
import NotificationTimestamp from "../subcomponents/NotificationTimestamp";
function formatCause(cause: string): string {
  return cause.replaceAll("_", " ").toLowerCase().replaceAll(/\b\w/g, c => c.toUpperCase());
}
function formatContextValue(value: unknown): string | null {
  if (value === null || value === undefined) return null;
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return null;
}
function ContextDetails(t0) {
  const $ = _c(5);
  const {
    context
  } = t0;
  if (!context || Object.keys(context).length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== context) {
    t1 = Object.entries(context).map(_temp).filter(_temp2);
    $[0] = context;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const displayableEntries = t1;
  if (displayableEntries.length === 0) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="tw-mr-1 tw-text-xs tw-font-bold tw-text-iron-400">•</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== displayableEntries) {
    t3 = <>{t2}<div className="tw-flex tw-flex-wrap tw-gap-x-3 tw-gap-y-1">{displayableEntries.map(_temp3)}</div></>;
    $[3] = displayableEntries;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp3(t0) {
  const [key_0, value_0] = t0;
  return <span key={key_0} className="tw-text-xs tw-text-iron-500"><span className="tw-text-iron-600">{key_0}:</span> {value_0}</span>;
}
function _temp2(entry) {
  return entry[1] !== null;
}
function _temp(t0) {
  const [key, value] = t0;
  return [key, formatContextValue(value)] as const;
}
function NotificationContent(t0) {
  const $ = _c(10);
  const {
    causeLabel,
    createdAt,
    context
  } = t0;
  let t1;
  if ($[0] !== causeLabel) {
    t1 = <span className="tw-text-sm tw-font-normal tw-text-iron-400">{causeLabel}</span>;
    $[0] = causeLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== createdAt) {
    t2 = <NotificationTimestamp createdAt={createdAt} />;
    $[2] = createdAt;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== context) {
    t3 = <ContextDetails context={context} />;
    $[4] = context;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export default function NotificationGeneric(t0) {
  const $ = _c(21);
  const {
    notification
  } = t0;
  let t1;
  if ($[0] !== notification.cause) {
    t1 = formatCause(notification.cause);
    $[0] = notification.cause;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const causeLabel = t1;
  if (notification.related_identity) {
    let t2;
    if ($[2] !== causeLabel || $[3] !== notification.additional_context || $[4] !== notification.created_at) {
      t2 = <NotificationContent causeLabel={causeLabel} createdAt={notification.created_at} context={notification.additional_context} />;
      $[2] = causeLabel;
      $[3] = notification.additional_context;
      $[4] = notification.created_at;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== notification.related_identity || $[7] !== t2) {
      t3 = <div className="tw-w-full"><NotificationHeader author={notification.related_identity}>{t2}</NotificationHeader></div>;
      $[6] = notification.related_identity;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  let t2;
  if ($[9] !== causeLabel) {
    t2 = <span className="tw-text-sm tw-font-medium tw-text-iron-300">{causeLabel}</span>;
    $[9] = causeLabel;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== notification.created_at) {
    t3 = <NotificationTimestamp createdAt={notification.created_at} />;
    $[11] = notification.created_at;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2">{t2}{t3}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== notification.additional_context) {
    t5 = <ContextDetails context={notification.additional_context} />;
    $[16] = notification.additional_context;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <div className="tw-w-full tw-py-2">{t4}{t5}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}